module.exports = __webpack_public_path__ + "Poppins-Light.b2b23d2504016419aa88.ttf";


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/fc0fc15e/0/notifi/notifi-web-site/src/assets/fonts/Poppins-Light.ttf
// module id = ../../../../../src/assets/fonts/Poppins-Light.ttf
// module chunks = 2